import { createSelector } from 'reselect'
import { TStoreUi }       from "store/ui/d";
import { TReduxStore }    from "store/index";

export const _selectorUILoading = createSelector((state: TReduxStore): TStoreUi => state.ui, ui => ui.loading)

export const _selectorUIIsSkeleton = createSelector((state: TReduxStore): TStoreUi => state.ui, ui => ui.loading?.isSkeleton)

export const _selectorUIIsMiniLoading = createSelector((state: TReduxStore): TStoreUi => state.ui, ui => ui.loading?.isMini)
